import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteGroupById, getCurrentIdentityGroups } from "../../actions/api";
import { Popconfirm, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { clearSelectedGroup } from "../../actions";
import { errorAction, types } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../util";

const GroupDeletionAction = ({ groupId }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDelete = async () => {
    setLoading(true);

    const deletionResponse = await dispatch(deleteGroupById(groupId));

    if (deletionResponse?.type === errorAction(types.DELETE_GROUP_BY_ID)) {
      const title = deletionResponse?.payload?.title || "Error";
      const message = deletionResponse?.payload?.data?.message || "Unknown";

      showErrorNotification(title, message);
      setLoading(false);
      return;
    }

    navigate("/groups/admin");
    setTimeout(() => {
      dispatch(clearSelectedGroup());
      dispatch(getCurrentIdentityGroups());
      setLoading(false);
    }, 0);
  };

  return (
    <Popconfirm
      title="Are you sure you want to delete this group?"
      onConfirm={handleDelete}
      okText="Yes"
      cancelText="No"
    >
      <Button
        id="deleteGroupButton"
        danger
        icon={<DeleteOutlined />}
        type="primary"
        loading={loading}
      >
        Delete
      </Button>
    </Popconfirm>
  );
};

GroupDeletionAction.propTypes = {
  groupId: PropTypes.string.isRequired,
};

export default GroupDeletionAction;
